import { useEffect, useState } from 'react';
import { Form, Input, Divider, Select, InputNumber, Button, Space } from 'antd';
import MyDatePicker from '../antdCommon/DatePicker';
import { PlusOutlined } from '@ant-design/icons';
import { backendUrl } from '../../Config';
import { ajaxFetchCall } from '../../services/ApiService';
import { convertToGraphQl, createGraphQlFilters } from '../../services/GarphQlConversionService';
import moment from 'moment';

export default function AddEditTransactionForm(props) {
    const [form] = Form.useForm()
    const [uniqueInvestedBy, setUniqueInvestedBy] = useState([]);
    const [uniqueName, setUniqueName] = useState("")
    const [mfs, setMfs] = useState([])
    const graphqlName = "GrowwMutualFundPagination"
    const navGraphqlName = "GrowwMutualFundNavPagination"

    useEffect(async () => {
        initialize()

        let map = {
            amount: props.amount,
            investedBy: props.investedBy,
        }
        if (props.date) {
            map.action = props.action
            map.mf = props.mf
            map.date = moment(props.date)
            getNavOfMutualFund(map.mf, map.date)
        }
        form.setFieldsValue(map)
        calculateQuantity()
    }, [])


    let initialize = async () => {
        await getUniqueInvestBy()
        await getAllMutualFunds()
    }


    const getAllMutualFunds = async () => {
        let q1 = convertToGraphQl(graphqlName, null, ["fund_name",], null, 1, 100000)
        let body = JSON.stringify({
            query: q1
        });
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })
        setMfs(data["data"][graphqlName]["items"])
    }



    const allMfsOptions = () => {
        let children = []
        for (let mf of mfs) {
            children.push(<Select.Option value={mf._id} key={mf._id}>{mf.fund_name}</Select.Option>);
        }
        return children
    }

    let getUniqueInvestBy = async () => {
        let data = await ajaxFetchCall(backendUrl + "/user/distinct/usertransactions/investedBy")
        setUniqueInvestedBy(data['response'].map((item) => { return { label: item, value: item } }))
    }

    const onFinish = async (values) => {
        if (props.transactionId) {
            values["transactionId"] = props.transactionId
        }
        await props.onFinish(values)
        form.resetFields();
    }

    const onValuesChange = (changedValues, allValues) => {
        if (changedValues['date'] || changedValues['mf']) {
            getNavOfMutualFund(allValues['mf'], allValues['date'])
        }
        if (changedValues['qty'] && allValues['amount']) {
            form.setFieldsValue({ nav: (allValues['amount'] / allValues['qty']).toFixed(2) })
        } else {
            if (!changedValues['qty']) {
                calculateQuantity()
            }
        }

    }

    const onUniqueNameChange = (event) => {
        setUniqueName(event.target.value);
    };

    const addItem = () => {
        let temp = [...uniqueInvestedBy, { label: uniqueName, value: uniqueName }]
        setUniqueInvestedBy(temp)
    }

    const calculateQuantity = () => {
        console.log("running ");

        let nav = form.getFieldValue('nav')
        let amount = form.getFieldValue('amount')
        if (nav && amount) {
            let q = amount / nav
            form.setFieldsValue({ qty: q.toFixed(2) })
        } else {
            form.setFieldsValue({ qty: "" })
        }
    }



    const getNavOfMutualFund = async (mf, date) => {
        if (mf && date) {
            let d = [moment(date).startOf('day'), moment(date).endOf('day')]
            let q1 = convertToGraphQl(navGraphqlName, createGraphQlFilters({ mutualFund: [mf] }), ["nav",], null, 1, 1, d, "date")
            let body = JSON.stringify({
                query: q1
            });
            let data = await ajaxFetchCall(backendUrl + "/graphql", {
                method: "POST",
                body: body
            })
            if (data["data"][navGraphqlName]["items"] && data["data"][navGraphqlName]["items"][0]) {
                form.setFieldsValue({ nav: data["data"][navGraphqlName]["items"][0]['nav'] })

            } else {
                form.setFieldsValue({ nav: "" })
                form.setFields([{ name: "nav", 'errors': ["Nav not Found for this combination"] }])
            }
            calculateQuantity()
        }
    }


    return (
        <Form form={form} name="basic" onFinish={onFinish} labelCol={{ span: 5 }} onValuesChange={onValuesChange}>

            <Form.Item label="Invested By" name="investedBy">
                <Select showSearch={true} placeholder="Invested By" options={uniqueInvestedBy}
                    dropdownRender={(menu) => (
                        <>
                            {menu}
                            <Divider
                                style={{
                                    margin: '8px 0',
                                }}
                            />
                            <Space
                                style={{
                                    padding: '0 8px 4px',
                                }}
                            >
                                <Input
                                    placeholder="Please enter Name"
                                    onChange={onUniqueNameChange}
                                />
                                <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                    Add item
                                </Button>
                            </Space>
                        </>
                    )}
                >
                </Select>
            </Form.Item>

            <Form.Item label="Action" name="action" rules={[
                {
                    required: true,
                    message: 'Action Required!',
                },
            ]}>
                <Select placeholder="Action" defaultValue={props.action ? props.action : null}>
                    <Select.Option value="Buy">Buy</Select.Option>
                    <Select.Option value="Sell">Sell</Select.Option>
                </Select>
            </Form.Item>

            <Form.Item label="Mutual Fund" name="mf" rules={[
                {
                    required: true,
                    message: 'Mutual Fund Required!',
                },
            ]} >
                <Select placeholder="Mutual Fund" showSearch={true} filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // defaultValue={props.mf ? props.mf : null}
                >
                    {allMfsOptions()}
                </Select>
            </Form.Item>

            <Form.Item label="Date" name="date"

            >
                <MyDatePicker style={{ width: '100%' }}
                // initialValues={props.data ? props.date : null} 
                />
            </Form.Item>

            <Form.Item label="Amount" name="amount" rules={[
                {
                    required: true,
                    message: 'Amount is Required',
                },
            ]}>
                <InputNumber style={{ width: '100%' }}
                ></InputNumber>
            </Form.Item>

            <Form.Item label="Nav" name="nav">
                <Input ></Input>
            </Form.Item>

            <Form.Item label="Quantity" name="qty" >
                <Input ></Input>
            </Form.Item>

            <Form.Item >
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
    )
}